import DesktopView from './DesktopView'
import MobileAppBody from './MobileAppBody'
import MobileView from './MobileView'
import StoreBtn from './MobileView/StoreBtn'
import {
  Body,
  QrCode,
  QrTitle,
  QrWrapper,
  StoreBtnWrapper,
  Subtitle,
  Title,
  TitleWrapper,
} from './style'

export {
  MobileView,
  DesktopView,
  StoreBtn,
  Body,
  QrCode,
  QrTitle,
  QrWrapper,
  StoreBtnWrapper,
  Subtitle,
  Title,
  TitleWrapper,
  MobileAppBody,
}
